import { useQuery } from 'react-query';
import { useService } from 'shared/providers';

export function useQueryQuoteBrands() {
  const { quoteService } = useService();
  const { data, isLoading, isFetching } = useQuery<string[], Error>(['quote-brands'], () =>
    quoteService.getQuoteBrands()
  );

  return { brandsOptions: data, isLoading, isFetching } as const;
}
